module.exports = __webpack_public_path__ + "img/icon_staff.ea4dc5b0.png";